import { createStore } from 'vuex'

export default createStore({
  state: {
    user: {
      username: '',
      user_id: '0',
      role: '0',
      blogger_name: "",
      blogger: {}
    },
    platforms: [],
    platformsData: [],
    isOpenFloat: false,
    isMinimizedFloat: false,
    ismaterialSuccess: false,
  },
  mutations: {
    setIsmaterialSuccess: (state, ismaterialSuccess) => {
      state.ismaterialSuccess = ismaterialSuccess
    },
    setIsOpenFloat: (state, isOpenFloat) => {
      state.isOpenFloat = isOpenFloat
    },
    setIsMinimizedFloat: (state, isMinimizedFloat) => {
      state.isMinimizedFloat = isMinimizedFloat
    },
    setLogin: (state, user) => {
      state.user = user
    },
    setPlatforms: (state, platforms) => {
      state.platforms = platforms
    },
    setPlatformsData: (state, platformsData) => {
      state.platformsData = platformsData
    } 
  },
  actions: {
  },
  modules: {
  }
})
